module.exports = __webpack_public_path__ + "static/media/relaxmit-3.ae948277.jpg";